import { useContext } from "react";
import { store } from "../utils/store";
import HomeDashboard from "../components/HomeDashboard";
import DashboardStats from "../components/DashboardStats";
import { fullname, role, email } from "../utils/data";

function Home(){
  const { state } = useContext(store);
  
  // Get current user info from localStorage
  const currentUser = {
    role: localStorage.getItem(role) || 'user',
    fullname: localStorage.getItem(fullname) || 'User',
    email: localStorage.getItem(email) || ''
  };

  return (
    <HomeDashboard currentUser={currentUser}>
      {currentUser.role.toLowerCase() === 'admin' && (
        <DashboardStats currentUser={currentUser} />
      )}
    </HomeDashboard>
  );
}

export default Home;